import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import PageHeading from "../../../components/common/PageHeading";
import RightBar from "../../../components/common/RightBar";
import RightBarMethod from "../../../components/common/RightBar/RightBarMethod";
import MultiSelect from "../../../components/common/MultiSelect";
import FilterContainer from "../../../components/common/FilterContainer";
import { getDocs, collection, doc, query, where } from "firebase/firestore";
import { auth, db } from "../../../firebase";
import { Space, Select, Button, Form, DatePicker, Col, Row, Spin } from "antd";
import { Rentalstatus } from "../../../data/rentalapplications";

import "./RentalApplications.css";
import EmailRentalApplication from "../../../components/common/EmailRentalApplication";
import { useForm } from "antd/lib/form/Form";
import { toast } from "react-hot-toast";
import moment from "moment";

import { useAuthState } from "react-firebase-hooks/auth";

const options = [];
for (let i = 10; i < 36; i++) {
  options.push({
    label: i.toString(36) + i,
    value: i.toString(36) + i,
  });
}

function RentalApplications() {
  const [isConfirmationBoxOpen, setIsConfirmationBoxOpen] = useState(false);
  const [search, setSearch] = useState(false);
  const [rentalApplicationsData, setRentalApplicationsData] = useState([]);
  const [applicants, setApplicants] = useState([]);
  const [properties, setProperties] = useState([]);
  const [propertyUnits, setPropertyUnits] = useState([]);
  const [statusType, setStatusType] = useState([]);
  const [filteredDataSource, setFilteredDataSource] = useState([]);
  const [appliNames, setAppliNames] = useState([]);
  const [contactDetail, setContactDetail] = useState("");
  const [desiredMoveIn, setDesiredMoveIn] = useState("");
  const [desiredEndIn, setDesiredEndIn] = useState("");
  const [user, loading] = useAuthState(auth);
  const [companyName, setcompanyName] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigate();
  const [form] = useForm();

  const RentalApplicationsRightBar = [
    RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
      RightBarMethod(
        "New Rental Application",
        "1",
        "",
        "",
        "/leasing/rental-applications/NewRentalApplications"
      ),
      RightBarMethod(
        <span onClick={() => setIsConfirmationBoxOpen(true)}>
          Email Rental Application
        </span>,
        "2",
        "",
        "",
        ""
      ),
      RightBarMethod(
        "Customize Application",
        "3",
        "",
        "",
        "/generalsettings/rental-application-customization"
      ),
      RightBarMethod(
        "Rental Application Fees",
        "4",
        "",
        "",
        "/generalsettings/rental-application-fees"
      ),
      RightBarMethod(
        "Bulk Update Application Fees",
        "5",
        "",
        "",
        "/leasing/rental-applications/bulk-update-application-fees"
      ),
      RightBarMethod(
        "Screening Criteria Templates",
        "6",
        "",
        "",
        "/generalsettings/screening-criteria"
      ),
    ]),

    RightBarMethod(
      " REPORTS",
      "t2",
      <i className="fa-solid fa-chart-column"></i>,
      [
        RightBarMethod("Rental Applications", "7", "", "", "/"),
        RightBarMethod("Tenant Directory", "8", "", "", "/"),
        RightBarMethod("Unit Vacancy Detail", "9", "", "", "/"),
        RightBarMethod("Prospect Source Tracking", "10", "", "", "/"),
        RightBarMethod("Owner Leasing", "11", "", "", "/"),
        RightBarMethod("Leasing Agent Performance", "12", "", "", "/"),
      ]
    ),

    RightBarMethod(
      " HELP TOPICS",
      "t4",
      <i className="fa-solid fa-circle-question"></i>,
      [
        RightBarMethod("Online Applications", "13", "", "", "/"),
        RightBarMethod("Application Fees", "14", "", "", "/"),
      ]
    ),
  ];

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));

      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            // console.log(res, "companyName")
            setcompanyName(res.companyName);
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  const handleFormSubmit = () => {
    const formData = form.getFieldsValue();

    setContactDetail(formData.contactInfo);
    setStatusType(formData.StatusType);

    const formattedStartDate = formData.startDate
      ? moment(formData.startDate).format("YYYY-MM-DD")
      : "";
    const formattedEndDate = formData.endDate
      ? moment(formData.endDate).format("YYYY-MM-DD")
      : "";

    setDesiredMoveIn(formattedStartDate);
    setDesiredEndIn(formattedEndDate);

    Object.keys(formData).forEach((field) => {
      if (formData[field] === undefined) {
        formData[field] = "";
      }
    });

    let dataSource = properties.filter((record) =>
      record?.propertyNameAddress?.propertyName
        ?.toLowerCase()
        .includes(formData.propertiesUnit?.toLowerCase() || "")
    );

    if (formData.contactInfo) {
      dataSource = dataSource.filter((property) =>
        property.applicants.some((applicant) =>
          `${applicant?.information?.legalFirstName} ${applicant?.information?.lastName}`.includes(
            formData.contactInfo
          )
        )
      );
    }

    setFilteredDataSource(dataSource);
  };

  const onFinishFailed = (errorInfo) => {
    toast.error("There are problems with one or more required fields");
    console.log("Failed:", errorInfo);
  };
  const propArray = [];
  useEffect(() => {
    if (companyName) {
      const fetchProperties = async () => {
        try {
          const propertyRef = collection(
            db,
            "companies",
            companyName,
            "properties"
          );
          const snapshot = await getDocs(propertyRef);
          let fetchedData = snapshot.docs.map((doc) => ({
            id: doc.id,
            value: doc.data().propertyNameAddress.propertyName,
            label: doc.data().propertyNameAddress.propertyName,
            applicants: rentalApplicationsData.filter(
              (item1) => doc.id === item1?.rentalUnit?.unit
            ),
            ...doc.data(),
          }));

          fetchedData.map((property) => {
            propArray.push(property?.value);
          });
          // Filter properties that have an associated rental application
          fetchedData = fetchedData.filter(
            (property) => property.applicants.length > 0
          );

          setFilteredDataSource(fetchedData);
          setProperties(fetchedData);
          const applicantsArr = [];
          fetchedData.forEach((property) => {
            if (property.applicants && property.applicants.length > 0) {
              property.applicants.forEach((applicant) => {
                applicantsArr.push({
                  id: applicant.id,
                  label: `${applicant?.information?.legalFirstName} ${applicant?.information?.lastName}`,
                  value: `${applicant?.information?.legalFirstName} ${applicant?.information?.lastName}`,
                });
              });
            }
          });
          setAppliNames(applicantsArr);
        } catch (err) {
          console.error(err);
        }
      };
      fetchProperties();
    }
  }, [rentalApplicationsData, companyName]);

  useEffect(() => {
    setIsLoading(true);
    if (companyName) {
      const companiesRef = collection(db, "companies");
      const companyDocRef = doc(companiesRef, companyName);
      const rentalApplicationRef = collection(
        companyDocRef,
        "rentalApplications"
      );
      const getRentalApplications = async () => {
        const data = await getDocs(rentalApplicationRef);
        const rentalApplicationsData = data.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }));

        setRentalApplicationsData(rentalApplicationsData);
        setIsLoading(false);
      };
      getRentalApplications();
    }
  }, [companyName]);

  useEffect(() => {
    if (companyName) {
      const sameUnitApp = setProperties();

      setApplicants(sameUnitApp);
    }
  }, [companyName]);

  const propertiesArr = [];
  properties?.forEach((element) => {
    propertiesArr.push(element.value); // Push each element to the resultArray
  });
  return (
    <>
      {isLoading ? (
        <div className="spin-container">
          <Spin tip="Loading..." />
        </div>
      ) : (
        <>
          <div className="rental-applications">
            <PageHeading heading="Rental Applications" />
            <div className="row-container">
              <Row>
                <Col span={24}>
                  <FilterContainer heading="Filter applications by using any of the search filters below:">
                    <Form
                      name="basic"
                      labelCol={{
                        span: 6,
                      }}
                      wrapperCol={{
                        span: 16,
                      }}
                      initialValues={{
                        remember: true,
                      }}
                      autoComplete="off"
                      colon={false}
                      onFinish={handleFormSubmit}
                      onFinishFailed={onFinishFailed}
                      form={form}
                    >
                      <Form.Item
                        label="Properties, Units or Campaigns"
                        name="propertiesUnit" // Correct the name attribute
                      >
                        <MultiSelect
                          options={propertiesArr}
                          placeholder="Search by unit, property, group, campaign or portfolio"
                          callBackItems={setPropertyUnits} // Use onChange instead of callBackItems
                        />
                      </Form.Item>
                      <Form.Item label="Contact Info" name="contactInfo">
                        <Select
                          showSearch
                          allowClear
                          placeholder="Search by name, email address, or phone"
                          optionFilterProp="children"
                          options={appliNames}
                        />
                      </Form.Item>
                      <Form.Item label="Status" name="StatusType">
                        <MultiSelect
                          options={Rentalstatus}
                          placeholder="Search by status"
                          callBackItems={setStatusType}
                        />
                      </Form.Item>
                      <Form.Item label="  ">
                        <Row justify="space-between" align="middle">
                          <Col>
                            <Space className="dtepckr" direction="vertical">
                              <Form.Item label="Available" name={"startDate"}>
                                <DatePicker />
                              </Form.Item>
                            </Space>
                          </Col>
                          <Col>
                            <span>To</span>
                          </Col>
                          <Col>
                            <Space className="dtepckr" direction="vertical">
                              <Form.Item name={"endDate"}>
                                <DatePicker />
                              </Form.Item>
                            </Space>
                          </Col>
                        </Row>
                      </Form.Item>

                      <Form.Item label=" ">
                        <Button
                          type="primary"
                          htmlType="submit"
                          onClick={() => setSearch(true)}
                        >
                          Search
                        </Button>
                      </Form.Item>
                    </Form>
                  </FilterContainer>
                </Col>
              </Row>
              <Row justify="center">
                <Col>
                  <p className="filter-critera">
                    Adjust your filter criteria or{" "}
                    <Link to="/leasing/rental-applications/NewRentalApplications">
                      add a new rental application.
                    </Link>
                  </p>
                </Col>
              </Row>
              {filteredDataSource?.map((item, index) => {
                return (
                  <Row className="property-data" key={index} gutter={[0, 24]}>
                    <Col span={24}>
                      <Row gutter={[30, 0]}>
                        <Col>
                          {item?.attachments ? (
                            <img
                              src={item?.attachments[0]?.downloadURL}
                              alt="property"
                            />
                          ) : (
                            <img
                              src="https://www.shutterstock.com/image-photo/property-taxes-real-estate-market-260nw-1700575657.jpg"
                              alt="property-"
                            />
                          )}
                        </Col>
                        <Col>
                          <a href="/nothing" style={{ fontSize: "20px" }}>
                            {item?.propertyNameAddress?.propertyName
                              ? item?.propertyNameAddress?.propertyName
                              : "--"}
                          </a>
                        </Col>
                        <Col className="main-details-container">
                          <Row className="details-container">
                            <Col className="details">
                              <span className="silver-text">Address: </span>{" "}
                              <p>
                                {item?.propertyNameAddress?.addressLine1
                                  ? item?.propertyNameAddress?.addressLine1
                                  : "--" +
                                    ", " +
                                    item?.propertyNameAddress?.state
                                  ? item?.propertyNameAddress?.state
                                  : "--" +
                                    " ," +
                                    item?.propertyNameAddress?.zipCode
                                  ? item?.propertyNameAddress?.zipCode
                                  : "--"}
                              </p>
                            </Col>
                            <Col className="details">
                              <span className="silver-text">Market Rent:</span>
                              <p>
                                $
                                {item?.rentalInformation?.marketRent
                                  ? item?.rentalInformation?.marketRent
                                  : "--"}
                              </p>
                            </Col>
                            <Col className="details">
                              <span className="silver-text">Vacant On: </span>{" "}
                              <p>
                                {item?.marketingInformation?.availableOn
                                  ? item?.marketingInformation?.availableOn
                                  : "--"}
                              </p>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                    <Col span={24}>
                      <Row>
                        <Col span={24}>
                          <Row className="header-row">
                            <Col className="col-span header" span={4}>
                              Applicant(s)
                            </Col>
                            <Col className="col-span header" span={4}>
                              Desired Move In
                            </Col>
                            <Col className="col-span header" span={4}>
                              Status
                            </Col>
                            <Col className="col-span header" span={4}>
                              Residential History
                            </Col>
                            <Col className="col-span header" span={4}>
                              Received
                            </Col>
                          </Row>
                        </Col>

                        {item?.applicants
                          ?.filter(
                            (user) =>
                              (user?.information?.phoneNumbers?.length > 1
                                ? user?.information?.phoneNumbers[0]
                                    ?.phoneNumber
                                : "--" +
                                    " " +
                                    user?.information?.legalFirstName +
                                    " " +
                                    user?.information?.lastName || ""
                              )?.includes(contactDetail || "") ||
                              (
                                user.residentialHistory.currentAddress
                                  .residedFrom || ""
                              )?.includes(desiredMoveIn || "") ||
                              (
                                user.residentialHistory.currentAddress
                                  .residedTo || ""
                              )?.includes(desiredEndIn || "")
                          )
                          .map((user, index) => {
                            return (
                              <Col
                                span={24}
                                key={index}
                                className="data-row"
                                onClick={() =>
                                  navigate(
                                    `/leasing/rental-applications/rental-application/${user.id}`
                                  )
                                }
                              >
                                <Row>
                                  <Col className="col-span" span={4}>
                                    <span className="onclick-text">
                                      {user.information.legalFirstName +
                                        " " +
                                        user.information.lastName}
                                    </span>
                                  </Col>
                                  <Col className="col-span" span={4}>
                                    {user.rentalUnit.desiredMoveIn}
                                  </Col>
                                  <Col className="col-span" span={4}>
                                    Converting
                                  </Col>
                                  <Col className="col-span" span={4}>
                                    {/* {user.residentailHistory} */}
                                    Non Requested
                                  </Col>
                                  <Col className="col-span" span={4}>
                                    {/* {user.RecievedDate} */}
                                    12-8-2023
                                  </Col>
                                </Row>
                              </Col>
                            );
                          })}
                      </Row>
                    </Col>
                  </Row>
                );
              })}
            </div>
          </div>
          <div className="RightSidebar">
            <RightBar RightBarData={RentalApplicationsRightBar} />
          </div>
          {isConfirmationBoxOpen ? (
            <EmailRentalApplication
              isConfirmationBoxOpen={isConfirmationBoxOpen}
              setIsConfirmationBoxOpen={setIsConfirmationBoxOpen}
            />
          ) : null}
        </>
      )}
    </>
  );
}
export default RentalApplications;
